import { BaseService } from "core/services";
import { FacilityOrderTemplateValidationRouteService } from "application/facility-order/services";

class FacilityOrderTemplateValidationService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new FacilityOrderTemplateValidationRouteService());
	}

	bulkUpdate(resources) {
        const url = this.routeService.bulkUpdate(resources);
        return this.apiClient.put(url, resources)
    }

	resolve(resource) {
		const url = this.routeService.resolve(resource);
		return this.apiClient.put(url, resource);
	}
}

export default FacilityOrderTemplateValidationService;